import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private apiUrl = environment.trackycontrol;

  constructor(private http: HttpClient) {}

  authenticate(): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/api/authenticate', environment.loginData).pipe(
      tap(response => {
        if (response.id_token) {
          sessionStorage.setItem('auth_token', response.id_token);
        }
      })
    );
  }

  getToken(): string | null {
    return sessionStorage.getItem('auth_token');
  }
}